/** @module csi/table/SubtypeTable */
define([
	"dojo/_base/declare",
	"csi/config",
	"csi/core/ExtendedPath",
	"csi/reflection",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare, config, ExtendedPath, reflection, Table, xml, Query) {

	return declare(Table, {
		/** @property {C8NodeType} subtypeClass - class owning the desired subtypes */
		subtypeClass: null,

		/** @property {C8AttributeId} subtypeOptionalSetting - setting containing subtype's map of optional attributes */
		subtypeOptionalSetting: null,

		/** @property {cnl} urlSubtype - the current Subtype */
		urlSubtype: null,

		/**
		 * Disable new action if selected Subtype is not available
		 * @param {Context} ctx
		 * @param {Action} action
		 * @return {Boolean}
		 */
		onAccessNew: function(ctx, action) {
			var store = config.getSubtypeStore(this.subtypeClass);

			if (store == null) {
				return false;
			}

			if (this.urlSubtype == null) {
				return true;
			}

			return !!store.get(this.urlSubtype);
		},

		/**
		 * @override
		 * Populate optional attributes map with those for configured subtype
		 */
		onCustomViewAttributeOptions(options) {
			const {subtypeClass, subtypeOptionalSetting, urlSubtype} = this;

			if (subtypeOptionalSetting) {
				const map = reflection.getSubtypeSetting(urlSubtype, subtypeOptionalSetting);
				if (map) {
					options.optionalAttributesMaps = {[ExtendedPath.create(subtypeClass)]: map};
				}
			}

			this.inherited(arguments);
		},

		/**
		* @override
		* update urlSubtype so that make prefKey updated properly
		*/
		_resolveView: function() {
			const {urlSubtype} = this;

			if (!this.bPopup) {
				const q = new Query().RefAttr(reflection.ATTR_SUBTYPE, xml.OP_EQUALS, urlSubtype);
				this.relRoot.addQuery(q, true);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Return object containing properties from view necessary to recreate it for the custom view preview
		 */
		getPreviewProperties() {
			const params = this.inherited(arguments);
			params.urlSubtype = this.urlSubtype;
			params.subtypeClass = this.subtypeClass;
			return params;
		},

		/**
		 * @override
		 * Return object containing properties from view necessary to recreate it for printing that are not custom view options
		 */
		getPrintProperties: function() {
			const params = this.inherited(arguments);
			params.urlSubtype = this.urlSubtype;
			params.subtypeClass = this.subtypeClass;
			return params;
		}
	});
});